export default "__VITE_ASSET__8330263e__"